import AppIcon from "../AppIcon"
import Image from "next/image"
import Link from "next/link"

interface ExpertCommentProps {
    firstName: string
    lastName: string
    jobTitle: string
    clickable: boolean
    comment: string
    authorPageUrl: string
    authorPageImg: string
}

const ExpertComment = ({firstName, lastName, jobTitle, clickable, comment, authorPageUrl, authorPageImg}: ExpertCommentProps) => {
    const authorImg = `/assets/avatars/editors/${authorPageImg}.png`
    const userName = `${firstName} ${lastName}`

    const authorBadge = (
        <div className={`flex ${clickable ? "cursor-pointer" : ""}`}>
            <div className="w-10 h-10 rounded-full bg-deep-green flex items-center justify-center shrink-0">
                <AppIcon
                    iconClassName="fa-quote-left"
                    type="solid"
                    size="lg"
                    className="text-pastel-green"
                />
            </div>


            <div className="flex gap-3 pr-5 rounded-full bg-pastel-yellow">
                <div className="relative flex items-center">
                    <div className="relative w-10 h-10 rounded-2xl overflow-hidden shrink-0">
                        <Image
                            src={authorImg}
                            alt={userName}
                            fill
                            sizes="40px"
                            className="object-cover"
                            onError={(e) => {
                                (e.target as HTMLImageElement).style.display = "none"
                            }}
                        />
                    </div>
                </div>

                <div className="flex flex-col leading-tight text-pale">
                    <span className="font-bold text-rm-14">{userName}</span>
                    <span className="text-rm-12">{jobTitle}</span>
                </div>
            </div>
        </div>
    )

    return (
        <div className="py-4">
            <div className="flex w-full justify-end">
                {clickable ? (
                    <Link href={authorPageUrl} className="no-underline">
                        {authorBadge}
                    </Link>
                ) : (
                    authorBadge
                )}
            </div>

            <div className="bg-white flex flex-col shadow rounded-2xl p-5">
                <div className="rounded-2xl">
                    <p className="italic text-pale text-rm-16 m-0">
                        {`"${comment}"`}
                    </p>
                </div>

                <div className="flex items-center w-fit p-1 gap-2 bg-rm-blue/20 text-rm-blue rounded-lg text-rm-12">
                    <AppIcon iconClassName="fa-circle-check" type="light" size="sm" />
                    <span>Informations vérifiées</span>
                </div>
            </div>
        </div>
    )
}

export default ExpertComment
